import { createSlice } from "@reduxjs/toolkit";

import { erpLogin } from "../../apis";

const UserLoginSlice = createSlice({
    name: 'userLogin',
    initialState: {
        isLoading: false,
        data : {},
        error: '',
        isLoginSuccess: false,
    },

    reducers: {
        emptyError: (state, action) => {
            state.error = action.payload
        },
    },

    extraReducers: (builder) => {
        builder.addCase(erpLogin.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(erpLogin.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.isLoginSuccess = true;
            state.data = action.payload.data;
        })
        builder.addCase(erpLogin.rejected, (state, action) => {
            console.error('inside rejected login slice: ', state, action)
            state.error = 'Please enter valid credentials!!!!!!'
            state.isLoading = false;
        })
    }
})

export const { emptyError } = UserLoginSlice.actions

export default UserLoginSlice.reducer;
